import React from "react";
import Assets from "imports/assets.import";
import "./rename_input.ui.scss";

interface IRenameInput {
  value: string;
  onChange: (value: string) => void;
  onSave: () => void;
  onCancel: () => void;
  error?: string;
  maxLength?: number;
  ariaLabel?: string;
  saveLabel?: string;
}

// An underline-only text field with a round tick button at the end. Enter or the tick saves, Escape cancels.
// The tick is disabled while `error` is set, and the error line keeps its height so the layout never shifts.
const RenameInput = (props: IRenameInput) => {
  const { value, onChange, onSave, onCancel, error = "", maxLength, ariaLabel, saveLabel } = props;

  return (
    <>
      <div className={`rename_input${error ? " rename_input_error" : ""}`}>
        <input
          autoFocus
          className="rename_input_field"
          aria-label={ariaLabel}
          maxLength={maxLength}
          value={value}
          onFocus={(event) => event.currentTarget.select()}
          onChange={(event) => onChange(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === "Enter") onSave();
            if (event.key === "Escape") onCancel();
          }}
        />
        <button type="button" className="rename_input_tick" aria-label={saveLabel} disabled={!!error} onClick={onSave}>
          <img src={Assets.check_ink} alt="" />
        </button>
      </div>
      <div className="rename_input_message" role="alert">{error}</div>
    </>
  );
};

export default RenameInput;
